import { dispatchOpenBatchExecutionDetailsModal } from '@Containers/Search/Shared/BatchExecutionDetails/BatchExecutionDetailsModalActions';

// was moved from BatchExecutionDetails service
// to avoid cycle dependency between BatchExecutionDetails service and BatchExecutionDetailsModalActions
// eslint-disable-next-line import/prefer-default-export
export const openBatchExecutionDetailsModal = (ids, closeCallback) => {
  dispatchOpenBatchExecutionDetailsModal({
    searchId: ids.searchId,
    databaseId: ids.databaseId,
    closeCallback,
  });
};
